export const GlobalsColorConstants = {
  COLOR_CULTURED: "#F4F4F4",
  COLOR_CRIMSON_RED: "#E0001B",
  COLOR_DARK_CERULEAN: "#004894",
};
